"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleProvider = LocaleProvider;
exports.LocaleReceiver = LocaleReceiver;
exports.useLocale = useLocale;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LocaleContext = /*#__PURE__*/_react.default.createContext();
function useLocale() {
  var context = (0, _react.useContext)(LocaleContext);
  if (!context) {
    throw new Error("useLocale must be used within a LocaleProvider");
  }
  return {
    locale: context
  };
}
function LocaleProvider(props) {
  var _useState = (0, _react.useState)(props.locale),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    locale = _useState2[0],
    setLocale = _useState2[1];
  (0, _react.useEffect)(function () {
    //Set to window for later use in various places like form validation messages
    if ((typeof window === "undefined" ? "undefined" : (0, _typeof2.default)(window)) === 'object') {
      window.__YKB_UI_LOCALE__ = props.locale;
    }
    setLocale(props.locale);
  }, [props.locale]);
  return /*#__PURE__*/_react.default.createElement(LocaleContext.Provider, {
    value: locale
  }, props.children);
}
function LocaleReceiver(props) {
  function getLocale(ykbUILocale) {
    var componentName = props.componentName,
      defaultLocale = props.defaultLocale;
    var localeFromContext = ykbUILocale && ykbUILocale[componentName];
    return _objectSpread(_objectSpread({}, typeof defaultLocale === 'function' ? defaultLocale() : defaultLocale), localeFromContext || {});
  }
  function getLocaleCode(ykbUILocale) {
    var localeCode = ykbUILocale && ykbUILocale.locale;
    if (!localeCode) return 'tr';
    return localeCode;
  }
  return /*#__PURE__*/_react.default.createElement(LocaleContext.Consumer, null, function (ykbUILocale) {
    return props.children(getLocaleCode(ykbUILocale), getLocale(ykbUILocale));
  });
}